import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteContentProvider } from "./context/SiteContentContext";

// Pages
import HomePage from "./pages/HomePage";
import QuemSomosPage from "./pages/QuemSomosPage";
import ServicosPage from "./pages/ServicosPage";
import DiferenciaisPage from "./pages/DiferenciaisPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContatoPage from "./pages/ContatoPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";

function App() {
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/quem-somos" element={<QuemSomosPage />} />
            <Route path="/servicos" element={<ServicosPage />} />
            <Route path="/diferenciais" element={<DiferenciaisPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          <Route path="/contato" element={<ContatoPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
